import { AbstractScatterVisualization } from './../visualization.abstract.scatter.component';
export class NmfGraph extends AbstractScatterVisualization {
}
